/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_ExplanationInputs */



/**
* | output |
* | --- |
* | "That way Wundo knows where you stand with the person you meet, and you get the right preparation and feedback in every 1:1." |
*
* @param {Manager_Question_ExplanationInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_explanation = /** @type {((inputs?: Manager_Question_ExplanationInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_ExplanationInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zo weet Wundo hoe je tegenover je gesprekspartner staat, en krijg je in elke 1:1 de juiste voorbereiding en feedback.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ainsi, Wundo sait quelle est votre position face à votre interlocuteur, et vous recevez la bonne préparation et le bon feedback pour chaque one-to-one.")
	return /** @type {LocalizedString} */ ("That way Wundo knows where you stand with the person you meet, and you get the right preparation and feedback in every 1:1.")
});